export const ThinkpowerColumns = [{
    title: 'SN',
    dataIndex: "SerialNumber",
    width: 160,
    fixed: 'left',
}, {
    title: 'CreateTime',
    dataIndex: 'CreateTime',
    width: 160,
    fixed: 'left',
}, {
    title: 'Mode',
    dataIndex: 'Mode',
    width: 160,
}, {
    title: 'Temp(°C)',
    dataIndex: 'Temp',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'VAC1Inv(V)',
    dataIndex: 'VAC1Inv',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC1Inv(A)',
    dataIndex: 'IAC1Inv',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'HzAC1Inv(Hz)',
    dataIndex: 'HzAC1Inv',
    width: 160,
    render: (v) => {
        const x = v * 0.01;
        return isNaN(x) ? "" : x.toFixed(2);
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'PAC1Inv(W)',
    dataIndex: 'PAC1Inv',
    width: 160,
}, {
    title: 'VAC2Inv(V)',
    dataIndex: 'VAC2Inv',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC2Inv(A)',
    dataIndex: 'IAC2Inv',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'HzAC2Inv(Hz)',
    dataIndex: 'HzAC2Inv',
    width: 160,
    render: (v) => {
        const x = v * 0.01;
        return isNaN(x) ? "" : x.toFixed(2);
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'PAC2Inv(W)',
    dataIndex: 'PAC2Inv',
    width: 160,
}, {
    title: 'VAC3Inv(V)',
    dataIndex: 'VAC3Inv',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC3Inv(A)',
    dataIndex: 'IAC3Inv',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'HzAC3Inv(Hz)',
    dataIndex: 'HzAC3Inv',
    width: 160,
    render: (v) => {
        const x = v * 0.01;
        return isNaN(x) ? "" : x.toFixed(2);
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'PAC3Inv(W)',
    dataIndex: 'PAC3Inv',
    width: 160,
}, {
    title: 'PInv(W)',
    dataIndex: 'PInv',
    width: 160,
}, {
    title: 'QInv',
    dataIndex: 'QInv',
    width: 160,
}, {
    title: 'PFInv',
    dataIndex: 'PFInv',
    width: 160,
    render: (v) => {
        const x = v * 0.01;
        return isNaN(x) ? "" : x.toFixed(2);
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'PDC(W)',
    dataIndex: 'PDC',
    width: 160,
}, {
    title: 'EDay(kWh)',
    dataIndex: 'EDay',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'ETotal(kWh)',
    dataIndex: 'ETotal',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'EDayToLoad(kWh)',
    dataIndex: 'EDayToLoad',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'ETotalToLoad(kWh)',
    dataIndex: 'ETotalToLoad',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'VMPPT1(V)',
    dataIndex: 'VMPPT1',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IMPPT1(A)',
    dataIndex: 'IMPPT1',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'VMPPT2(V)',
    dataIndex: 'VMPPT2',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IMPPT2(A)',
    dataIndex: 'IMPPT2',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'VMPPT3(V)',
    dataIndex: 'VMPPT3',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IMPPT3(A)',
    dataIndex: 'IMPPT3',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'PMPPT1(W)',
    dataIndex: 'PMPPT1',
    width: 160,
}, {
    title: 'PMPPT2(W)',
    dataIndex: 'PMPPT2',
    width: 160,
}, {
    title: 'PMPPT3(W)',
    dataIndex: 'PMPPT3',
    width: 160,
}, {
    title: 'VBat(V)',
    dataIndex: 'VBat',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IBat(A)',
    dataIndex: 'IBat',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'PBat(W)',
    dataIndex: 'PBat',
    width: 160,
}, {
    title: 'SOC',
    dataIndex: 'SOC',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'SOH',
    dataIndex: 'SOH',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'BatTemp(°C)',
    dataIndex: 'BatTemp',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'BatStatus',
    dataIndex: 'BatStatus',
    width: 160,
}, {
    title: 'EDayBatChrg(kWh)',
    dataIndex: 'EDayBatChrg',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'ETotalBatChrg(kWh)',
    dataIndex: 'ETotalBatChrg',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'EDayBatDischrg(kWh)',
    dataIndex: 'EDayBatDischrg',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'ETotalBatDischrg(kWh)',
    dataIndex: 'ETotalBatDischrg',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'BatChargeCurrentLimit(A)',
    dataIndex: 'BatChargeCurrentLimit',
    width: 200,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'BatDischargeCurrentLimit(A)',
    dataIndex: 'BatDischargeCurrentLimit',
    width: 200,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'BatCellMaxVoltage(V)',
    dataIndex: 'BatCellMaxVoltage',
    width: 200,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'BatCellMinVoltage(V)',
    dataIndex: 'BatCellMinVoltage',
    width: 200,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'BatCellMaxTemperature(°C)',
    dataIndex: 'BatCellMaxTemperature',
    width: 200,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'BatCellMinTemperature(°C)',
    dataIndex: 'BatCellMinTemperature',
    width: 200,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'BatChargeCutoffVoltage(V)',
    dataIndex: 'BatChargeCutoffVoltage',
    width: 200,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'BatDischargeCutoffVoltage(V)',
    dataIndex: 'BatDischargeCutoffVoltage',
    width: 200,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'EDayEPS(kWh)',
    dataIndex: 'EDayEPS',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'ETotalEPS(kWh)',
    dataIndex: 'ETotalEPS',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'EDayGEN(kWh)',
    dataIndex: 'EDayGEN',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
},
{
    title: 'PAC1LOAD(W)',
    dataIndex: 'PAC1LOAD',
    width: 160,
}, {
    title: 'PAC2LOAD(W)',
    dataIndex: 'PAC2LOAD',
    width: 160,
}, {
    title: 'PAC3LOAD(W)',
    dataIndex: 'PAC3LOAD',
    width: 160,
}, {
    title: 'VAC1LOAD(V)',
    dataIndex: 'VAC1LOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'VAC2LOAD(V)',
    dataIndex: 'VAC2LOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'VAC3LOAD(V)',
    dataIndex: 'VAC3LOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'EDayLOAD(kWh)',
    dataIndex: 'EDayLOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'ETotalLOAD(kWh)',
    dataIndex: 'ETotalLOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
},
{
    title: 'PAC1GRID(W)',
    dataIndex: 'PAC1GRID',
    width: 160,
}, {
    title: 'PAC2GRID(W)',
    dataIndex: 'PAC2GRID',
    width: 160,
}, {
    title: 'PAC3GRID(W)',
    dataIndex: 'PAC3GRID',
    width: 160,
}, {
    title: 'VAC1GRID(V)',
    dataIndex: 'VAC1GRID',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC1GRID(A)',
    dataIndex: 'IAC1GRID',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'VAC2GRID(V)',
    dataIndex: 'VAC2GRID',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC2GRID(A)',
    dataIndex: 'IAC2GRID',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'VAC3GRID(V)',
    dataIndex: 'VAC3GRID',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC3GRID(A)',
    dataIndex: 'IAC3GRID',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'EDayToGrid(kWh)',
    dataIndex: 'EDayToGrid',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'ETotalToGrid(kWh)',
    dataIndex: 'ETotalToGrid',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'EDayFromGrid(kWh)',
    dataIndex: 'EDayFromGrid',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'ETotalFromGrid(kWh)',
    dataIndex: 'ETotalFromGrid',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'ErrorCode1',
    dataIndex: 'ErrorCode1',
    width: 160,
}, {
    title: 'ErrorCode2',
    dataIndex: 'ErrorCode2',
    width: 160,
}, {
    title: 'ErrorCode3',
    dataIndex: 'ErrorCode3',
    width: 160,
},]